import React from "react";
import "./dropdownQuestion.css";

/**
 * DropdownQuestion ahora es controlado.
 * Recibe `value` desde el padre y notifica cambios con `updateProgress`.
 */
const DropdownQuestion = ({
  question,
  options,
  required,
  value = "",
  updateProgress
}) => {
  const handleChange = e => {
    const selectedValue = e.target.value;
    updateProgress(selectedValue);
  };

  return (
    <div className="dropdown-question">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <select
        className="dropdown-select"
        required={required}
        value={value}
        onChange={handleChange}
      >
        <option value="" disabled hidden>
          Selecciona una opción
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropdownQuestion;